function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { parseValidators } from '../util';
import Errors from './Errors';
var Hidden = function Hidden(_ref) {
  var messages = _ref.messages,
    name = _ref.name,
    _ref$styles = _ref.styles,
    styles = _ref$styles === void 0 ? {} : _ref$styles,
    validators = _ref.validators,
    _ref$onBlur = _ref.onBlur,
    _onBlur = _ref$onBlur === void 0 ? function () {} : _ref$onBlur;
  var _useFormContext = useFormContext(),
    register = _useFormContext.register;
  var registerProps = register(name, parseValidators({
    messages: messages,
    validators: validators
  }));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Errors, {
    name: name,
    styles: styles,
    messages: messages
  }), /*#__PURE__*/React.createElement("input", _extends({
    className: "form-control ".concat(styles && styles.controlClass ? styles.controlClass : ''),
    type: "hidden"
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, registerProps, {
    onBlur: function onBlur() {
      _onBlur.apply(void 0, arguments);
      return registerProps.onBlur.apply(registerProps, arguments);
    }
  })));
};
export default Hidden;